import { REMOVE_ALL_SUBPAGES } from '../constants';

import { createAction } from '../utils/redux';

export const removeAll = createAction(REMOVE_ALL_SUBPAGES);
